import { Injectable } from '@angular/core';
import { BaseWorkflowStateService } from '../base-workflow-state.service';
import { TermsAndConditionData } from '../../../../../../models/order/workflow/terms-conditions.model';


@Injectable({ providedIn: 'root' })
export class TermsAndConditionsStateService extends BaseWorkflowStateService<TermsAndConditionData> {
    override stateKey: string = 'termsAndConditions';
}